import React from 'react'

export const About = () => {
  return (
    <div>
      <h1 style={{paddingTop:100}}>About</h1>
    </div>
  )
}
